module.exports = __webpack_public_path__ + "img/citas.d09d326b.svg";